import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { BillingMonth, BillingMonthSelect } from '@classes/billing-month-select';
import { BillingToDo } from '@classes/billing-to-do';

@Component({
  selector: 'app-month-select',
  templateUrl: './month-select.component.html',
  styleUrls: ['./month-select.component.scss']
})
export class MonthSelectComponent implements OnInit {

  billingMonthSelects: BillingMonthSelect[] = [];
  selectedFilter: BillingMonth | null;

  listBillingToDo_: BillingToDo[] = [];
  @Input() set listBillingToDo(list: BillingToDo[]) {
    this.listBillingToDo_ = list;
    this.initComponent();
  }

  @ViewChild("billingMonthSelect", { static: true }) billingMonthSelectMatSelection: MatSelectionList;

  @Output() billingMonthSelectEmit = new EventEmitter<BillingMonthSelect | null>();

  constructor() { }

  ngOnInit() {
    this.billingMonthSelectMatSelection.selectionChange.subscribe(value => {
    })
  }

  initComponent() {
    this.billingMonthSelects = [];
    let years: (number | undefined)[] = [];
    years = this.listBillingToDo_.map(m => m.year).filter(this.onlyUnique) || [];

    years.sort((a, b) => (a || -1) - (b || -1)).forEach(year => {
      let billingMonthSelect = new BillingMonthSelect();
      billingMonthSelect.year = year || -1;
      let months = this.listBillingToDo_.filter(f => f.year == year).map(m => m.month).filter(this.onlyUnique) || [];

      months.sort((a, b) => (a || -1) - (b || -1)).forEach(month => {
        let billingMonth = new BillingMonth();
        billingMonth.month = month;
        billingMonthSelect.month.push(billingMonth);
      })

      this.billingMonthSelects.push(billingMonthSelect);
    })
  }

  private onlyUnique(value: any, index: number, self: any) {
    return self.indexOf(value) === index;
  }

  selectedBillingMonth(billingMonth: BillingMonth | null) {
    if (billingMonth) {
      this.billingMonthSelects.forEach(billingMonthSelect => {
        billingMonthSelect.month.forEach(month => {
          if (month.id == billingMonth.id) {
            const selectedBillingMonth = new BillingMonthSelect();
            selectedBillingMonth.year = billingMonthSelect.year;
            selectedBillingMonth.month = [month];
            this.selectedFilter = billingMonth;
            this.billingMonthSelectEmit.emit(selectedBillingMonth);
          }
        })
      })
    }
    else {
      this.selectedFilter = null;
      this.billingMonthSelectEmit.emit(null);
    }
  }
}
